

<div  [class.typeMonth]='typeMonthFlag' class="mycalendar">
 
  <div class="cal1 ">
      <div class="">
        <a class="setdown " (click)="setdown()">
          <nb-icon icon="arrow-ios-back" status="default"></nb-icon> 
        </a>
        <label class="showDate">
          <span class="">{{YYYY}}</span>年
          <span class="">{{MM+1}}</span>月
        </label>        
        <a class="setup" (click)="setup()">
          <nb-icon icon="arrow-ios-forward"  status="default"></nb-icon>
        </a>
        <label class="btn typeBtn " (click)="typeMonthFlag=true">年度</label>
      </div>
     
      <br>
    
      <div class="showCalendar">      
        <table>
          <tbody>
            <tr>
              <th>日</th>
              <th>一</th><th>二</th><th>三</th><th>四</th><th>五</th><th>六</th>
            </tr>
              <tr *ngFor="let tr of printDays">              
                <td *ngFor="let day of tr" (click)='selectD(day);' 
                (drop)="drop_handler($event,day);" (dragover)="dragover_handler($event);"
                  >
                  <!--   -->
                  <span *ngIf="day.DD !=''">{{ day.DD }}</span>
                  <div class="showInfo" >
                    <div class="showInfo_txt" *ngIf="day.info">
                      <label *ngFor="let info of day.info;let i = index" 
                      [class]="'t'+(i+1)" 
                      [style]=" 'background:'+ (info.color ? info.color : '#338a96')"
                      draggable="true" (dragstart)="dragstart_handler($event,info,day.DD)"
                     >
                        {{info.msg}}
                      </label>
                      <!-- 
                      <label class="red">公休</label>
                      <label class="t1">4:00-7:00</label>
                      <label class="t2">4:00-7:00</label>
                      <label class="t3">4:00-7:00</label>
                      <label class="t4">4:00-7:00</label> 
                      -->
                    </div>

                    <div class="showInfo_icon" *ngIf="day.info">
                      <label *ngFor="let info of day.info;let i = index" 
                      [class]="'t'+(i+1)" 
                      [style]=" 'background:'+ (info.color ? info.color : '#338a96')"
                      > </label>
                    </div>

                  </div>
                  
                </td>
              </tr>           
          </tbody>
        </table>
      </div>
      
    </div>
     <div class="cal2">
      <div class="">
        <a class="setdown " (click)="setYdown()">
          <nb-icon icon="arrow-ios-back" status="default"></nb-icon> 
        </a>
        <label class="showDate">
          <span class="">{{YYYY}}</span>
        </label>        
        <a class="setup" (click)="setYup()">
          <nb-icon icon="arrow-ios-forward"  status="default"></nb-icon>
        </a>        
        <label class="btn typeBtn" (click)="typeMonthFlag=false">返回</label>
      </div>      
      
      <div class="showCalendar">
        <table>
          <tbody>
            <tr>
              <th colspan="3"></th>
            </tr>
            <tr *ngFor="let tr of printMonth;let i = index">
              <td class="dminner" *ngFor="let mon of printMonth[i];let m =index" 
               (click)="selectM(m+i*3)" [class.on]='MM==m+i*3 ? true : flase'>{{mon}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>